angular.module('common.filter.decimalNumber', ['common.config', 'common.helper']).filter('decimalNumber', function(CONSTANTS, CommonHelper){
    return function(number, useNumberFraction, pNumberFraction) {
        if (isNaN((number))){
            return null;
        }

        var numberFraction = CONSTANTS.numberFraction;
        if (!isNaN(pNumberFraction)) {
            // Use parameter number fraction
            numberFraction = pNumberFraction;
        } else if (useNumberFraction) {
            // Use the number fraction from the input number
            numberFraction = CommonHelper.getNumberFraction(number);
        }

        return CommonHelper.formatDecimalNumber(number, numberFraction, CONSTANTS.thousandsSeparator, CONSTANTS.decimalSeparator);
  };
});



// WEBPACK FOOTER //
// ./app/common/filter/decimal-number-filter.js